import { Action } from 'redux';

import { ClearUserNotificationsState } from '../../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../../bootstrap/redux/actions/isActionFactory';

export interface ClearUserNotificationsStateAction extends Action { }

export function clearUserNotificationsStateAction(): ClearUserNotificationsStateAction {
  return {
    type: ClearUserNotificationsState,
  };
}

export const isClearUserNotificationsStateAction = isActionFactory<ClearUserNotificationsStateAction>(ClearUserNotificationsState);
